<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2025-04-24 11:38:35
 * @FilePath: \jsczt\src\views\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <!-- <div class="home" :style="{ transform: `scale(${scale})` }"> -->
  <div class="home" :style="{ zoom: scale, height: '100%' }">
    <div class="title">
      <div class="title_logo">
        <img src="../assets/jsczt_logo.png" alt="" />
      </div>
      <div class="title_txt">
        <a href="http://www.jiangsu.gov.cn/" target="_blank">江苏省政府 </a>
        |<a href="http://czt.jiangsu.gov.cn/" target="_blank">江苏省财政厅</a> |
        <!-- <a href="http://www.jszwfw.gov.cn/yjsgk/list.do" target="_blank">旧站回顾</a> -->
        <a href="http://yjsgk.jsczt.cn/yjsgk/list.do" target="_blank"
          >旧站回顾</a
        >
        <span style="color: #eb4766;">本系统为非涉密系统，严禁处理、传输涉密信息</span>
      </div>
    </div>
    <div class="cont">
      <div class="cont_text">江苏省预决算公开统一平台</div>
      <div class="cont_select">
        <div class="select_left">
          <el-select
            style="line-height:20px !important"
            v-model="value"
            :popper-append-to-body="false"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.channelid"
              :label="item.chnldesc"
              :value="item.chnlname"
              style="padding-left: 20px"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select_right">
          <div class="jsx">
            <div v-if="input" class="jsx_text" @click="getRegions">
              {{ curName }}
            </div>
          </div>
        </div>
        <div class="gobtn" @click="goto('overView', '预决算公开管理文件', '6')">
          GO
        </div>
      </div>
    </div>
    <div class="lastDiv">
      <div class="footer">
        <div class="footer_content">
          <div class="footer_left">
            <div class="footer_title">
              <img src="../assets/icon.png" />
              <p>预决算公开管理文件</p>
            </div>
            <ul v-for="item in yjsData" :key="item.classinfoid">
              <li @click="goto('overView', item.cname, item.classinfoid)">
                {{ item.cname }}
              </li>
            </ul>
          </div>
          <div class="footer_cent">
            <div class="footer_title">
              <img src="../assets/icon2.png" />
              <p>政府预决算公开</p>
            </div>
            <ul>
              <li
                v-for="item in zfyjsData"
                :key="item.classinfoid"
                @click="goto('overView2', item.cname, item.classinfoid)"
              >
                {{ item.cname }}
                <span
                  v-if="
                    item.classinfoid !== 10 &&
                    item.classinfoid !== 12 &&
                    item.classinfoid !== 24
                  "
                  style="margin-left: 10px"
                  >|</span
                >
              </li>
            </ul>
          </div>
          <div class="footer_right">
            <div class="footer_title">
              <img src="../assets/icon3.png" />
              <p>部门预决算公开</p>
            </div>
            <ul>
              <li
                v-for="item in bmyjsData"
                :key="item.classinfoid"
                @click="goto('overViews', item.cname, item.classinfoid)"
              >
                {{ item.cname }}
                <span
                  v-if="item.classinfoid !== 29 && item.classinfoid !== 32"
                  style="margin-left: 10px"
                  >|</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footers">
        <div class="footercont">
          主办：江苏省财政厅 备案序号：苏ICP备15009401号
          公安备案号：32010602010331 网站标识码：3200000098 江苏省财政厅版权所有
          <div class="jiucuo">
            <span id="_span_jiucuo">
              <img @click="Link('3200000003')" style="border:0;cursor: pointer;" src="../assets/jiucuonew.png">
            </span>
          </div>
          <div class="dzjg">
            <span id="_ideConac">
              <a href="https://bszs.conac.cn/sitename?method=show&amp;id=105DF988641221CBE053012819ACE317" target="_blank">
                <img id="imgConac" vspace="0" hspace="0" border="0" src="../assets/red.png"></a>
              </span>
            </div>
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        :visible.sync="dwDialog"
        :append-to-body="true"
        class="my_dialog"
        :style="{ zoom: scale }"
        style="background-color: rgba(43, 94, 141, 0.8)"
      >
        <homeDialog2 @curtext="getcurText" :year="value"></homeDialog2>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dwDialog = false">取 消</el-button>
          <el-button type="primary" @click="updateArea">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import homeDialog2 from '../components/homeDialog2'
export default {
  name: 'Home',
  components: {
    homeDialog2
  },
  data () {
    return {
      options: [],
      value: '',
      dwDialog: false,
      yjsData: [],
      zfyjsData: [],
      bmyjsData: [],
      input: {},
      curArea: {},
      curName: '',
      scale: 1, // 初始缩放比例
      ymZoom: 1
    }
  },
  computed: {
    getWindowSize () {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val) {
          this.getXzqh()
        }
      },
      deep: true,
      immediate: true
    },
    scale: {
      handler (val) {
        window.addEventListener('load', this.handleResize)
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler (val) {
        this.handleResize()
      },
      deep: true,
      immediate: true
    }
  },
  async created () {
    await this.getYear()
    await this.getTree()
    window.addEventListener('load', this.handleResize)
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    Link (sitecode) {
      // 该站点需要纠错页面的url地址
      var url = "http://yjsgk.jsczt.cn/#/"

      // 跳转至纠错系统填写页面
      window.open('http://121.43.68.40/exposure/jiucuo.html?site_code=' + sitecode + '&url=' + encodeURIComponent(url))
    },
    handleResize () {
      var width = this.getWindowSize.width
      // 假设你设计稿的宽度是 1920px
      var designWidth = 1900
      var scale = width / designWidth
      this.scale = scale.toFixed(2)
      this.detectZoom()
    },
    detectZoom () {
      var ratio = 0
      var screen = window.screen
      var ua = navigator.userAgent.toLowerCase()
      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth
      }
      if (ratio) {
        ratio = Math.round(ratio * 100)
      }
      this.ymZoom = ratio
      // if (ratio > 100) {
      //   this.ymZoom = 100 / ratio
      // } else if (ratio === 100) {
      //   this.ymZoom = 1
      // } else {
      //   this.ymZoom = ratio / 100
      // }
    },
    updateArea () {
      this.dwDialog = false
      this.input = this.curArea
    },
    getcurText (data) {
      this.curArea = data
      this.curName = data.chnldesc
    },
    getRegions () {
      this.dwDialog = true
    },
    goto (path, item, crid) {
      var id = crid
      var cname = item
      var data = {
        classinfoid: id
      }
      if (cname === '政府预算') {
        data.classinfoid = 15
      }
      if (cname === '政府决算') {
        data.classinfoid = 18
      }
      if (cname === '政府调整预算') {
        data.classinfoid = 22
      }
      var datas = {
        cname: cname,
        place: this.curName ? this.curName : this.input.chnldesc,
        code: this.input.code,
        year: this.value,
        parentid: this.input.chnlid
      }
      data.classinfoid = data.classinfoid.toString()
      data.year = this.value
      data.code = this.input.code
      data.parentid = this.input.chnlid
      localStorage.setItem('key', JSON.stringify(datas))
      localStorage.setItem('year', this.value)
      this.$router.push({ name: path, query: { ...data } })
    },
    // 获取年份
    getYear () {
      this.$http.get('/api/wcmchannel/findYear').then((res) => {
        this.options = res.data.data
        this.value = this.options[0].chnlname
      })
    },
    // 获取行政区
    async getXzqh () {
      await this.$http
        .get('/api/wcmchannel/findxzqh', {
          params: {
            year: this.value,
            openType: 'ys'
          }
        })
        .then((res) => {
          this.input = res.data.data
          this.curName = this.input.chnldesc
        })
    },
    // 底部部门
    async getTree () {
      await this.$http
        .get('/api/classinfo/getTree', {
          params: {
            topId: '2'
          }
        })
        .then((res) => {
          res.data.data.chlid.forEach((item) => {
            if (item.cname === '预决算公开管理文件') {
              this.yjsData = item.chlid
            }
            if (item.cname === '政府预决算公开') {
              this.zfyjsData = item.chlid
            }
            if (item.cname === '部门预决算公开') {
              this.bmyjsData = item.chlid
            }
          })
        })
    }
  }
}
</script>
<style scoped>

@import url("../assets/home.css");

</style>



// WEBPACK FOOTER //
// src/views/Home.vue